import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getSelectedEducationClass = (state) => state.selectedEducationClass;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getSelectedEducationClass,
};
